import {getSheetHeader} from './Header'
import {Array2XLSX} from './Array2XLSX'
import {getSheetRoot} from './Root'

export const ContractTemp_1=(title,selectedItems,BuyerInfo,SellerInfo,ContractTerm)=>{
  const length=selectedItems.length
  let arr = selectedItems.map((item,index) =>{
    return [
    index+1,
    item.Name?item.Name:'',
    item.Description?item.Description:'',
    item.Unit?item.Unit:'',
    item.Quantity?item.Quantity:0,
    item.Inquiry.Currency=='USD'?'$'+item.Inquiry.UnitPrice:'￥'+item.Inquiry.UnitPrice,
    '',
    '',
    ''
  ]})
  arr.unshift(...getSheetHeader(BuyerInfo,SellerInfo));
  arr.push(...getSheetRoot(ContractTerm,BuyerInfo,SellerInfo))
  Array2XLSX(arr,title,length)
}
